import { Button } from '@winnin/winnin_ui.components.button'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { ReactSelect as Select } from 'components'
import { useTranslate } from 'lib/tolgee'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import { MODAL_STYLE } from './transfer-dashboard-modal.consts'
import { translations } from './transfer-dashboard-modal.i18n'
import type { ITransferDashboardModalReturn } from './transfer-dashboard-modal.types'

import './transfer-dashboard-modal.styles.scss'

export const TransferDashboardModalView = ({
  isOpen,
  handleClose,
  workspacesOptions,
  handleChange,
  handleSubmit,
  workspace,
  loading,
}: ITransferDashboardModalReturn) => {
  const t = useTranslate()

  return (
    <Modal style={MODAL_STYLE} isOpen={isOpen} appElement={document.body} onRequestClose={handleClose}>
      <div className="TemplateNameModalContent">
        <Title tag="h3">{t(translations.title)}</Title>
        {t(translations.subtitle)}
        <Select
          label={t(translations.inputTitle)}
          className="filter"
          onChange={handleChange}
          value={workspace}
          name="filter"
          options={workspacesOptions}
        />
        <div className="buttonsSection">
          <Button appearance="link" onClick={handleClose}>
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button disabled={!workspace || loading} onClick={handleSubmit}>
            {t(translations.buttonTransfer)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
